module.exports = __webpack_public_path__ + "static/media/hittite_text_06.ab9c896e.jpg";